import { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const ContactUs = () => {

    const [destination, setDestination] = useState("")
    const [contactData, setContactData] = useState(null);


    const handleShow = async (e) => {
        try {
            const payload = {
                AuthToken: "NASSKD28462RWKF35793FWEU757",
                destination
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Contact/GetContactUsDetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status === "SUCCESS") {
                //toast.success(data.message);
                setContactData(data)
            } else if (data.status === "ERROR") {
                toast.error(data.message);
                setContactData(null);
            }

        } catch (error) {
            console.error("Error saving user:", error);
            toast.error("Failed to save user. ");
        } finally {
        }
    };

    return (
        <>
<section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className='img-fluid' alt="" />
                </div>
            </section>

            {/* MAIN SECTION */}
            <section className="main-section">
                <div className="container">
                    {/* Welcome */}
                    <div className="bg-white rounded-3 p-4 mb-4 shadow-sm">

                        <h2 className="section-title">
                            Rate & Taxes
                        </h2>
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="contact-title">Head Office</div>
                                <h3 className="h5" style={{ color: 'var(--red)' }}>
                                    Oxford Express Private Limited
                                </h3>
                                <p><b>B-9 Laxmi Bhawan 72, Nehru place New Delhi - 110019.</b></p>
                                <p><a className="text-black" href="tel:+91 96672 33072">011 - 41606842</a>,  <a className="text-black" href="tel:096432 32088">096432 32088</a></p>
                            </div>

                            <div className="col-md-6">
                                <div className="contact-title">Branch Office</div>
                                <h3 className="h5" style={{ color: 'var(--red)' }}>
                                    Oxford Express Private Limited
                                </h3>
                                <p><b>Stall No-2, Shankar Market, Near Super Market,Connaught Place, New Delhi - 110001.</b></p>
                                <p><a className="text-black" href="tel:011-32502557">011 - 32502557</a>,  <a className="text-black" href="tel:8882622572">8882622572</a></p>
                            </div>
                        </div>

                    </div>

                    {/* destination */}
                    <div className="destination-wrap">
                        <p>To Find Contact information Please Select Destination:</p>
                        <div className="search-wrap mb-0 w-100">
                            <div className="destination">
                                <span>Destination</span>
                            </div>
                            <i className="fa fa-search s-icon"></i>
                            <select
                                value={destination }
                                name="ddlDeatination"
                                id="ddlDeatination"
                                class="textbox1"
                                onChange={(e) => setDestination(e.target.value)}
                            >
                                <option className="text-black-50"
                                        value="">--Select Destination--</option>
                                <option value="AGRA">AGRA</option>
                                <option value="AHEMDABAD">AHEMDABAD</option>
                                <option value="ALIGARH">ALIGARH</option>
                                <option value="ALLAHABAD">ALLAHABAD</option>
                                <option value="ALWAR">ALWAR</option>
                                <option value="AMBALA">AMBALA</option>
                                <option value="AMRITSAR">AMRITSAR</option>
                                <option value="AURANGABAD - MH">AURANGABAD - MH</option>
                                <option value="BANGALORE">BANGALORE</option>
                                <option value="BAREILLY">BAREILLY</option>
                                <option value="BHANDARA">BHANDARA</option>
                                <option value="BHILAI">BHILAI</option>
                                <option value="BHIWADI">BHIWADI</option>
                                <option value="BHOPAL">BHOPAL</option>
                                <option value="BHUBNESHWAR">BHUBNESHWAR</option>
                                <option value="BURDWAN">BURDWAN</option>
                                <option value="CALCUTTA">CALCUTTA</option>
                                <option value="CALCUTTA 24 PARGNAS NORTH">CALCUTTA 24 PARGNAS NORTH</option>
                                <option value="CALCUTTA 24 PARGNAS SOUTH">CALCUTTA 24 PARGNAS SOUTH</option>
                                <option value="CHANDIGARH">CHANDIGARH</option>
                                <option value="CHANDRAPUR">CHANDRAPUR</option>
                                <option value="CHENNAI">CHENNAI</option>
                                <option value="COCHIN">COCHIN</option>
                                <option value="COIMBATORE">COIMBATORE</option>
                                <option value="DEHRADUN">DEHRADUN</option>
                                <option value="DELHI ( CONNAUGHT PLACE)">DELHI ( CONNAUGHT PLACE)</option>
                                <option value="DELHI ( LAXMI NAGAR)">DELHI ( LAXMI NAGAR)</option>
                                <option value="DELHI (NEHRU PLACE)">DELHI (NEHRU PLACE)</option>
                                <option value="DELHI (WAZIRPUR)">DELHI (WAZIRPUR)</option>
                                <option value="DURGAPUR">DURGAPUR</option>
                                <option value="ETAHWA">ETAHWA</option>
                                <option value="FARIDABAD">FARIDABAD</option>
                                <option value="GHAZIABAD">GHAZIABAD</option>
                                <option value="GURGAON">GURGAON</option>
                                <option value="GUWAHATI">GUWAHATI</option>
                                <option value="GWALIOR">GWALIOR</option>
                                <option value="HARIDWAR">HARIDWAR</option>
                                <option value="HISSAR">HISSAR</option>
                                <option value="HOWRAH">HOWRAH</option>
                                <option value="HYDERABAD">HYDERABAD</option>
                                <option value="INDORE">INDORE</option>
                                <option value="JABALPUR">JABALPUR</option>
                                <option value="JAIPUR">JAIPUR</option>
                                <option value="JALANDHAR">JALANDHAR</option>
                                <option value="JAMMU">JAMMU</option>
                                <option value="JAMSHEDPUR VIA PATNA">JAMSHEDPUR VIA PATNA</option>
                                <option value="JHANSI">JHANSI</option>
                                <option value="JODHPUR">JODHPUR</option>
                                <option value="KANPUR">KANPUR</option>
                                <option value="KOLHAPUR">KOLHAPUR</option>
                                <option value="KOLKATA">KOLKATA</option>
                                <option value="KOTA">KOTA</option>
                                <option value="LUCKHNOW">LUCKHNOW</option>
                                <option value="LUDHIANA (N.DOX)">LUDHIANA (N.DOX)</option>
                                <option value="MADHURAI">MADHURAI</option>
                                <option value="MATHURA">MATHURA</option>
                                <option value="MEERUT">MEERUT</option>
                                <option value="MEERUT (DOX ONLY)">MEERUT (DOX ONLY)</option>
                                <option value="MORADABAD">MORADABAD</option>
                                <option value="MUMBAI">MUMBAI</option>
                                <option value="MUMBAI(LAMINTON)">MUMBAI(LAMINTON)</option>
                                <option value="NAGPUR">NAGPUR</option>
                                <option value="NASIK">NASIK</option>
                                <option value="NOIDA">NOIDA</option>
                                <option value="PANIPAT">PANIPAT</option>
                                <option value="PATNA">PATNA</option>
                                <option value="PUNE">PUNE</option>
                                <option value="RAIPUR">RAIPUR</option>
                                <option value="RAJKOT">RAJKOT</option>
                                <option value="RAMPUR">RAMPUR</option>
                                <option value="RANCHI">RANCHI</option>
                                <option value="RANCHI (VIA PATNA)">RANCHI (VIA PATNA)</option>
                                <option value="ROORKEE">ROORKEE</option>
                                <option value="SAWAI MADHOPUR">SAWAI MADHOPUR</option>
                                <option value="SIKAR">SIKAR</option>
                                <option value="SILCHAR">SILCHAR</option>
                                <option value="SILIGURI">SILIGURI</option>
                                <option value="SRI GANGA NAGAR">SRI GANGA NAGAR</option>
                                <option value="SRINAGAR (J&amp;K)">SRINAGAR (J&amp;K)</option>
                                <option value="SURAT">SURAT</option>
                                <option value="UDAIPUR">UDAIPUR</option>
                                <option value="VADODARA">VADODARA</option>
                                <option value="VARANASI">VARANASI</option>
                                <option value="VIJAYAWADA">VIJAYAWADA</option>
                                <option value="VISHAKAPATNAM">VISHAKAPATNAM</option>
                                <option value="YAVATMAL">YAVATMAL</option>

                            </select>
                            <button className="search-btn" onClick={handleShow }>
                                <i className="fa fa-arrow-right me-1"></i> Find Contact
                            </button>
                        </div>
                    </div>
                </div>

                {contactData && (
                    <div className="mt-3 w-50 mx-auto border rounded overflow-hidden shadow-sm">

                        <div className="position-relative bg-white p-2">

                            <button
                                type="button"
                                className="btn-close position-absolute top-0 end-0 m-2"
                                onClick={() => {
                                    setContactData(null);
                                    setDestination("");
                                }}
                            ></button>

                            <table className="table table-bordered mb-0 text-start align-middle">
                                <thead>
                                    <tr className="table-primary text-center">
                                        <th style={{ width: "60%" }}>
                                            ADDRESS & DESTINATION
                                        </th>
                                        <th style={{ width: "40%" }}>
                                            CONTACT PERSON
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {/* LEFT SIDE */}
                                        <td>
                                            <div>{contactData.address}</div>
                                            <div>{contactData.place}</div>
                                            <div> <b>{contactData.destination}</b></div>
                                        </td>

                                        {/* RIGHT SIDE */}
                                        <td>
                                            <div>
                                                <b>
                                                    {contactData.contactPerson || "-"}
                                                </b>
                                            </div>

                                            <div className="mt-2">
                                                Ph :
                                                {" "}
                                                {contactData.phoneNo || "-"}
                                            </div>

                                            <div>
                                                Mob :
                                                {" "}
                                                <span className="text-danger">
                                                    {contactData.mobNo || "-"}
                                                </span>
                                            </div>

                                            <div>
                                                Fax :
                                                {" "}
                                                {contactData.faxNo || "-"}
                                            </div>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

            </section>
        </>
    )
}

export default ContactUs
